/**
 * @class JsonSerializable
 * @abstract
 */
export class JsonSerializable {
  /**
   * Abstract converter to convert from generic
   * Javascript object to Class
   * @abstract
   * @param {Object} object
   * @return {*}
   */
  static fromJSON (object) {
    throw new Error('To use JsonSerializable the class must overwrite fromObject in the extending class')
  }

  /**
   * Abstract converter to convert from Class
   * generic Javascript object
   * @abstract
   * @return {Object}
   */
  toJSON () {
    throw new Error('To use JsonSerializable the class must overwrite toObject in the extending class')
  }
}
